import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import { ProgressSpinner } from "primereact/progressspinner";
import { Checkbox } from "primereact/checkbox";
import { Message } from "primereact/message";

import {
  useAddCampaignContent,
  useAddPlaylistContent,
} from "../../../../queries";
import { useScrollLoadingContext } from "../../../Contexts/ScrollLoadingContext";
import { setLastElement } from "../../../../redux/Slices/scrollSlice";
import ScrollContainer from "../../ScrollContainer";
import SearchInput from "../SearchInput";

function WeatherList() {
  const { ids, setIds } = useScrollLoadingContext();
  const { isFetching, data } = useSelector((state) => state.scroll);
  const { assign, layer } = useSelector((state) => state.global);
  const screenDetails = useSelector((state) => state.layout.screenDetails);
  const lastElementRef = useRef(null);

  const addCampaignContent = useAddCampaignContent();
  const addPlaylistContent = useAddPlaylistContent();
  const dispatch = useDispatch();
  const { id } = useParams();

  const onMediaChange = (e) => {
    let selectedMedia = [...ids];

    if (e.checked) selectedMedia.push(e.value);
    else selectedMedia.splice(selectedMedia.indexOf(e.value), 1);

    setIds(selectedMedia);
  };

  useEffect(() => {
    if (assign) {
      assignHandler();
    }
  }, [assign]);

  const assignHandler = async () => {
    if (window.location.pathname.includes("playlist"))
      await addPlaylistContent.mutateAsync({
        list_media_ids: ids,
        playlist_id: id,
        layer: layer,
      });
    else {
      await addCampaignContent.mutateAsync({
        ids_list: ids,
        campaign_id: window.location.pathname.includes("layout")
          ? screenDetails.id
          : id,
        layer: layer,
        type: "media",
      });
    }
  };

  useEffect(() => {
    if (lastElementRef.current) {
      dispatch(setLastElement(lastElementRef.current));
    }
  }, [lastElementRef.current]);

  return (
    <>
      <SearchInput isDisabled={data?.length === 0} />

      <ScrollContainer path={`/weather/all`}>
        {data?.length == 0 && !isFetching ? (
          <div className="w-100 flex justify-center items-center h-full">
            <Message
              className="fw-bold fs-3 p-4 w-75 mt-5 text-center"
              severity="warn"
              text="There were no Weathers added!"
            />
          </div>
        ) : (
          <div className="d-flex flex-column scroll_container scroll_div w-100">
            <div className="d-flex flex-wrap mt-2 mb-4 ">
              {data.map((item, index) => {
                return (
                  <div
                    ref={index === data?.length - 1 ? lastElementRef : null}
                    className={`px-2 w-100 d-flex align-items-center justify-content-between me-3 py-2
                       ${ids.indexOf(`${item.id}`) !== -1 ? "bg-gray-200" : ""}
                       ${index + 1 === data.length ? "" : "border-bottom"}`}
                    key={`${item?.type}-${index}`}
                  >
                    <label htmlFor={item?.id} className="col-11 d-flex ">
                      <div className={`col-2 mx-2 `}>
                        <div className="p-3 d-flex bg-secondary align-items-center justify-content-center playlist_icon_container w-75">
                          <i className="fa-solid fa-cloud-sun fs-3 text-white"></i>
                        </div>
                      </div>
                      <div className="col-9 col-sm-6 col-md-3 mx-1 fs-6 d-flex align-items-center text-truncate">
                        {item?.file_name?.split(".")[0]}
                      </div>
                      <div className="col-3 d-flex align-items-center justify-content-center d-none d-sm-flex text-capitalize fs-6 text-light fst-italic">
                        <span>
                          {item?.type === "HDMI"
                            ? item?.type
                            : item?.type?.toLowerCase()}
                        </span>
                      </div>
                    </label>
                    <div className="col-2 col-sm-1 me-3">
                      <Checkbox
                        inputId={item?.id}
                        name="media"
                        className="me-3"
                        value={item?.id}
                        onChange={onMediaChange}
                        checked={ids.indexOf(`${item?.id}`) !== -1}
                      />
                    </div>
                  </div>
                );
              })}

              {isFetching && data?.length ? (
                <ProgressSpinner
                  style={{ width: "60px", height: "60px", opacity: 0.1 }}
                  strokeWidth="3"
                  fill="var(--surface-ground)"
                  animationDuration="1s"
                />
              ) : (
                <></>
              )}
            </div>
          </div>
        )}
      </ScrollContainer>
    </>
  );
}

export default WeatherList;
